import { searchOrganisationUsers } from '@infuse/api/iam/organisation';
import { searchTenantUsers } from '@infuse/api/iam/tenant';
import { searchUsers } from '@infuse/api/iam/user';
import { UserLevel } from '@infuse/iam/user/type';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { useGenericUsers } from './generic/useGenericUsers';

export const useUsers = () => {
  const { level, user } = useCurrentUserStore();

  if (level === UserLevel.ORGANISATION) {
    return useGenericUsers({
      apiFn: searchOrganisationUsers,
      queryKeys: ['users', 'organisation'],
      onlyEnableWithParentId: true,
      initialParentId: user?.organisationId
    });
  } else if (level === UserLevel.TENANT) {
    return useGenericUsers({
      apiFn: searchTenantUsers,
      queryKeys: ['users', 'tenant'],
      onlyEnableWithParentId: true,
      initialParentId: user?.tenantId
    });
  }

  return useGenericUsers({
    apiFn: searchUsers,
    queryKeys: ['users']
  });
};
